/**
 * RoleGate — 404s users whose role does not match the allow-list.
 *
 * Used to protect /admin/platform/* routes. Renders a generic
 * "not found" rather than "forbidden" to mirror the API's
 * existence-not-leaked posture (cross-tenant 404s).
 */

import { type ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RoleGate({
  allow,
  children,
}: {
  allow: string[];
  children: ReactNode;
}) {
  const { loading, principal } = useAuth();

  if (loading) {
    return <div className="auth-loading" role="status">Loading...</div>;
  }

  if (principal === null || !allow.includes(principal.role)) {
    return (
      <div className="auth-shell">
        <div className="auth-card">
          <h1 className="auth-title">Page not found</h1>
          <p className="auth-subtle">
            The page you tried to open does not exist, or you do not have
            access to it.
          </p>
          <div className="auth-links">
            <Link to="/">Back to workspace</Link>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
